// Tournament glossary entries shared by the terms page and the prerender.
module.exports = [
  {
    term: "Addon",
    def: "An optional extra purchase of chips, usually available once at the end of the rebuy period. Often cheaper per chip than a rebuy."
  },
  {
    term: "Ante",
    def: "A forced bet every player posts before the hand, on top of blinds in some structures. Antes accelerate action and grow pots earlier."
  },
  {
    term: "Blind levels",
    def: "Timed steps that raise the forced bets (blinds/antes). Shorter levels speed the tournament; longer levels favor deeper play."
  },
  {
    term: "Bounty",
    def: "A cash reward for eliminating a player. In progressive knockouts (PKO), part of each bounty is kept and part is added to your own bounty."
  },
  {
    term: "Bubble",
    def: "The stage just before the money. The next elimination ends unpaid finishes; the following finishers are “in the money” (ITM)."
  },
  {
    term: "Bullet",
    def: "One entry or re-entry into a tournament. “Firing a second bullet” means buying back in after busting during late registration."
  },
  {
    term: "Buy-in",
    def: "The cost to enter. Often shown as prize-pool amount plus house fee (e.g. $100 + $20), or as one combined total."
  },
  {
    term: "Daily (daily tournament)",
    def: "A recurring tournament on a room’s regular calendar — often every day or the same weekday — typically smaller than festival “majors.”"
  },
  {
    term: "Freezeout",
    def: "A format with one entry only. If you lose all your chips, you are out; no rebuy or re-entry."
  },
  {
    term: "Guaranteed (GTD)",
    def: "A posted minimum prize pool. If buy-ins fall short, the house adds money so the pool still hits the guarantee."
  },
  {
    term: "ITM (in the money)",
    def: "Finishing high enough to earn a prize-pool payout. The cut line depends on field size and the posted payout structure."
  },
  {
    term: "Late registration",
    def: "The window after the official start when new players (and often re-entries) can still join. Usually closes after a set number of levels."
  },
  {
    term: "Level",
    def: "One step on the blind schedule. When the level changes, blinds (and often antes) rise; late registration is usually counted in levels."
  },
  {
    term: "NLH (No-Limit Hold’em)",
    def: "The most common tournament game. Players may bet any amount up to their stack; each player gets two hole cards and shares five community cards."
  },
  {
    term: "PLO (Pot-Limit Omaha)",
    def: "Omaha played pot-limit: you get four hole cards and must use exactly two with three board cards. Bet sizes cannot exceed the pot."
  },
  {
    term: "Re-entry",
    def: "Buying a fresh entry after busting, usually during late registration. Each entry is a new “bullet” with a full starting stack."
  },
  {
    term: "Rebuy",
    def: "Buying more chips after dropping to a threshold (or busting) during an early period. Common in “rebuy” tournaments; distinct from full re-entry at some rooms."
  },
  {
    term: "Satellite",
    def: "A tournament whose main prizes are seats (or packages) into a larger event, rather than only cash. Buy-ins are often much lower than the target event."
  },
  {
    term: "Starting stack",
    def: "The chip amount each player receives at the start (or on re-entry). Larger stacks relative to blinds usually mean longer average play."
  },
  {
    term: "Structure",
    def: "The combination of starting stack, blind schedule, level length, and any rebuy/re-entry rules that shape how fast the tournament plays."
  },
  {
    term: "Turbo",
    def: "A fast structure with short blind levels (and often shallower stacks). Fields bust quicker; variance is usually higher than deep structures."
  }
];



// WEBPACK FOOTER //
// ./js/glossary-terms.js